import React from 'react'
import { useRef, useEffect, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import './Loader.css'
import I from '../assets/Loading Screen.png'
import { useTranslation } from 'react-i18next';
import I2 from '../assets/Loading Screen2.png'
import ScrollTrigger from 'gsap/ScrollTrigger';

const Loader = ({ setLoading }) => {
const comp =useRef(null);

const { t, i18n } = useTranslation();
const currentLanguage = i18n.language;

const getImageForLanguage = (lang) => {
    switch (lang) {
      case 'az':
        return I2;
      case 'en':
      default:
        return I;
    }
  };

useEffect(() => {
    // GSAP animation for entering
    gsap.fromTo(comp.current, { y: 0 }, { y: 100, opacity: 0, delay: 0.5, duration: 2, ease: 'power2.in', onComplete: () => setLoading(false) });
  }, [setLoading]);

  return (
    <div className='loader' ref={comp}>
        <img alt="" className='loader_img'   src={getImageForLanguage(currentLanguage)}/>
    </div>
  )
}

export default Loader